import { render, staticRenderFns } from "./department.vue?vue&type=template&id=b8db564c&"
import script from "./department.vue?vue&type=script&lang=js&"
export * from "./department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8db564c')) {
      api.createRecord('b8db564c', component.options)
    } else {
      api.reload('b8db564c', component.options)
    }
    module.hot.accept("./department.vue?vue&type=template&id=b8db564c&", function () {
      api.rerender('b8db564c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/department.vue"
export default component.exports